module.exports = __webpack_public_path__ + "img/wei.27c5af77.png";